import React from 'react';

import classnames from 'classnames'
import ConditionEditor from './ConditionEditor';

const SideOverView = (props) => {
  const { condition, editId } = props
  // const { onConfirm, onCancel, onFirstUpdate } = props

  const conEditClassname = classnames('side-over-view', {
    'on': editId
  })

  return (
    <div className={conEditClassname} >
      {
        condition && (
          <ConditionEditor {...props} />
        )
      }
    </div>
  )
}

export default SideOverView